import { net } from 'zf-web-infra';
import type * as Types from './types';

/** OAuth 授权确认页接口。 */
export class OAuthConsentService {

  /** 获取待确认的授权交互。 */
  async getInteraction(interaction: string): Promise<Types.OAuthInteraction> {
    return await net.get<Types.OAuthInteraction>('/api/oauth/interaction', { interaction });
  }

  /** 提交允许或拒绝。 */
  async decide(request: Types.OAuthDecisionRequest): Promise<Types.OAuthDecisionResponse> {
    return await net.post<Types.OAuthDecisionResponse>('/api/oauth/decision', request);
  }

  /** 注销本次 OAuth 授权使用的平台登录 Token。 */
  async logout(request: Types.OAuthLogoutRequest): Promise<void> {
    await net.post('/api/account/logout', request);
  }

}
